import { MapPin, Clock } from "lucide-react";
import { AZIENDA } from "@/lib/config";

const COMUNI = ["Rimini", "Riccione", "Cattolica", "Misano Adriatico", "Bellaria-Igea Marina", "Santarcangelo di Romagna", "Coriano", "Morciano di Romagna", "Verucchio", "Novafeltria"];

export const ZonaServita = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16 sm:py-20" data-testid="zona-servita-section">
    <div className="rounded-3xl bg-sky-600 text-white p-8 sm:p-12 grid lg:grid-cols-12 gap-8 items-center">
      <div className="lg:col-span-5">
        <p className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-sky-100"><Clock className="w-4 h-4" /> Servizio H24</p>
        <h2 className="mt-2 text-2xl sm:text-3xl font-bold tracking-tight">Interveniamo in tutta la provincia di Rimini</h2>
        <p className="mt-3 text-sky-100">Giorno e notte, festivi inclusi. Chiamaci al <a href={AZIENDA.telefonoLink} className="font-bold text-white underline" data-testid="zona-call-link">{AZIENDA.telefono}</a>.</p>
      </div>
      <ul className="lg:col-span-7 flex flex-wrap gap-2" data-testid="zona-comuni-list">
        {COMUNI.map((c) => (
          <li key={c} className="inline-flex items-center gap-1.5 rounded-full bg-white/15 border border-white/25 px-3 py-1.5 text-sm font-semibold"><MapPin className="w-3.5 h-3.5" /> {c}</li>
        ))}
        <li className="inline-flex items-center rounded-full bg-white text-sky-700 px-3 py-1.5 text-sm font-bold">e tutti i comuni della provincia</li>
      </ul>
    </div>
  </section>
);
